import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../../../providers";
import { SubscriptionsReportControllerImpl } from "../../../../business/impl";
import { ISubscriptionsReportData } from "../../interfaces/factories";

export interface ISubscriptionReportHeader {
    handleData: React.Dispatch<React.SetStateAction<ISubscriptionsReportData>>
}
export const SubscriptionReportHeader: React.FC<ISubscriptionReportHeader> = ({ handleData }) => {
    const { t } = useTranslation('reports');
    const navigate = useNavigate();
    const { setCallbackLogin, handleLogout } = useAuth();
    const [isLoading, setLoading] = useState<boolean>(false);
    const [formData, setFormData] = useState({
        status: "all",
        plan: "all",
        dueDate: ""
    });

    const controller = new SubscriptionsReportControllerImpl();

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const parameters = `status=${formData.status}&plan=${formData.plan}&dueDate=${formData.dueDate}`;
        try {
            const subscriptionsReportData = await controller.getSubscriptionsReportData(parameters);
            setLoading(false);
            handleData(subscriptionsReportData);
        } catch (error) {
            if (error === "401") {
                setCallbackLogin(
                    {
                        goBack: true,
                        origin: '/adm/report/subscriptions',
                    }
                );
                handleLogout();
                navigate('/auth');
            } else {
                console.error("Erro na requisição:", error);
            }
            setLoading(false);
        }
    };

    return (
        <Form onSubmit={handleFormSubmit}>
            <fieldset disabled={isLoading}>
                <Row className="mb-3" style={{ fontSize: "12px" }}>
                    <Form.Group as={Col} controlId="formGridStatus">
                        <Form.Label>{t('status_label')}</Form.Label>
                        <Form.Select
                            value={formData.status || 'all'}
                            onChange={(e) => {
                                setFormData((prevData) => ({
                                    ...prevData,
                                    status: e.target.value,
                                }));
                            }}
                        >
                            <option value={'all'}>{t('all')}</option>
                            {Object.entries(
                                t('status_options', { returnObjects: true })).map(([key, value]) => (
                                    <option key={key} value={key}>
                                        {value}
                                    </option>
                                ))
                            }
                        </Form.Select>
                    </Form.Group>

                    <Form.Group as={Col} controlId="formGridPlans">
                        <Form.Label>{t('plans_label')}</Form.Label>
                        <Form.Select
                            value={formData.plan || 'all'}
                            onChange={(e) => {
                                setFormData((prevData) => ({
                                    ...prevData,
                                    plan: e.target.value,
                                }));
                            }}>
                            <option value={'all'}>{t('all')}</option>
                            {Object.entries(
                                t('plans_options', { returnObjects: true })).map(([key, value]) => (
                                    <option key={key} value={key}>
                                        {value}
                                    </option>
                                ))
                            }
                        </Form.Select>
                    </Form.Group>

                    <Form.Group as={Col} controlId="formGridDueDate">
                        <Form.Label>{t('due_date_input_label')}</Form.Label>
                        <Form.Control
                            type="date"
                            value={formData.dueDate}
                            onChange={
                                (e) =>
                                    setFormData((prevData) => ({
                                        ...prevData,
                                        dueDate: e.target.value,
                                    }))

                            }
                            autoComplete="off"
                        />
                    </Form.Group>
                </Row>

                <Button variant="primary" type="submit">
                    {t('search_button_label')}
                </Button>
            </fieldset>
        </Form>
    )
}